import PersonTaskList from './PersonTaskList';

export default PersonTaskList;
